<template>
  <div class="news-more">
      <!-- {{$route.params.renderContent}} -->
       <div class="header clearfix">
          <img class="fl" src="../../assets/logo-white.png" alt="" width="210">
            <ul class="fl">
                <li v-for="(item, index) in navList" :key="index">
                    <router-link :to="{name: 'Index', params: {renderContent: item.id}}">{{item.nav}}</router-link>
                </li>
            </ul>
            <!-- <span class="fr">EN</span> -->
        </div>
        <div class="banner"><img src="../../assets/banner.jpg" alt="" width="100%"></div>
        <div class="more">
            <span class="line"></span>
            <span class="text">更多新闻</span>
            <span class="line"></span>
        </div>
        <div class="news-content">
          <ul>
            <li v-for="(item,index) in newsList" :key="item.id" @click="showDetail(index)">
              <div class="img"><img :src="item.imgUrl" alt="" ></div>
              <div class="info">
                <span class="date">{{item.date}}</span>
                <span class="tit">{{item.tit}}</span>
              </div>
            </li>
          </ul>
            <!--<ul class="news-left fl">-->
                <!--<li v-for="(item, index) in newsList1" :key="item.id" @click="showDetail(item.id)">-->
                    <!--<div class="img"><img :src="item.imgUrl" alt="" ></div>-->
                    <!--<div class="info">-->
                        <!--<span class="date">{{item.date}}</span>-->
                        <!--<span class="tit">{{item.title}}</span>-->
                    <!--</div>-->
                <!--</li>-->
            <!--</ul>-->
            <!--<ul class="news-center fl">-->
                <!--<li v-for="(item, index) in newsList2" :key="item.id" @click="showDetail(item.id)">-->
                    <!--<div class="img"><img :src="item.imgUrl" alt=""></div>-->
                    <!--<div class="info">-->
                        <!--<span class="date">{{item.date}}</span>-->
                        <!--<span class="tit">{{item.title}}</span>-->
                    <!--</div>-->
                <!--</li>-->
            <!--</ul>-->
            <!--<ul class="news-right fl">-->
                <!--<li v-for="(item, index) in newsList3" :key="item.id" @click="showDetail(item.id)">-->
                    <!--<div class="img"><img :src="item.imgUrl" alt=""></div>-->
                    <!--<div class="info">-->
                        <!--<span class="date">{{item.date}}</span>-->
                        <!--<span class="tit">{{item.title}}</span>-->
                    <!--</div>-->
                <!--</li>-->
            <!--</ul>-->
        </div>

        <transition name="fade">
            <div class="mask" v-show="showMask">
                <div class="pop-box">
                    <span class="close" @click="closePop"></span>
                    <div class="pop" id="pop" v-if="showPopIndex !== -1">
                    <!-- <div> -->
                        <div class="tit-box">
                            <p class="tit">{{newsList[showPopIndex].tit}}</p>
                            <div class="line"></div>
                        </div>
                        <p class="time">{{newsList[showPopIndex].time}}</p>
                        <p class="summary clearfix" v-if="newsList[showPopIndex].summary">
                            <span class="fl hot" v-if="newsList[showPopIndex].hot">热点</span>
                            <span class="fr sum" v-if="newsList[showPopIndex].hot">{{newsList[showPopIndex].summary}}</span>
                            <span v-else>{{newsList[showPopIndex].summary}}</span>
                        </p>
                        <div class="detail" v-for="(items, index) in newsList[showPopIndex].content" :key="index">
                            <p class="detail-pic" v-if="items.pic"><img :src="items.pic" alt=""></p>
                            <p class="imgDetail" v-if="items.imgDetail">{{items.imgDetail}}</p>
                            <div v-else v-html="items.text"></div>
                        </div>
                    <!-- </div> -->
                    </div>
                    <span v-show="showPopIndex > 0" class="prev-btn" @click="turnPagePrev(showPopIndex)"></span>
                    <span v-show="showPopIndex < newsList.length - 1" class="next-btn" @click="turnPageNext(showPopIndex)"></span>
                </div>
            </div>
        </transition>
  </div>
</template>

<script>
// import img1 from './pic_news1.png'
import news1cover from './news1-cover.jpg'
import news2cover from './news2-cover.jpg'
import news3cover from './news3-cover.jpg'
import news4cover from './news4-cover.jpg'
import news5cover from './news5-cover.jpg'
import news6cover from './news6-cover.jpg'
import news7cover from './news7-cover.jpg'
import news8cover from './news8-cover.jpg'
import news9cover from './news-cqw.jpg'

import img2 from './pic_news2.jpg'
import detail1 from './detail1.jpg'
import detail2 from './detail2.jpg'
import detail3 from './detail3.jpg'
import detail4 from './detail4.jpg'

import news3detail1 from './pic1.jpeg'
import news3detail2 from './pic2.jpeg'

import news4detail1 from './news4detail1.jpg'
import news4detail2 from './news4detail2.jpg'
import news4detail3 from './news4detail3.jpg'
import news4detail4 from './news4detail4.jpg'
import news4detail5 from './news4detail5.jpg'

import news5detail1 from './news5detail1.png'
import news6detail1 from './news6detail1.jpg'
import news7detail1 from './news7detail1.jpg'

import aezboRveno from './aezbo-rveno.jpg'

export default {
  name: 'NewsMore',
  data () {
    return {
      showPopIndex: -1,
      showMask: false,
      navList: [
        {
          id: 0,
          nav: '认识我们'
        },
        {
          id: 1,
          nav: '管理团队'
        },
        {
          id: 2,
          nav: '基金分类'
        },
        {
          id: 3,
          nav: '投资案例'
        },
        {
          id: 4,
          nav: '最新资讯'
        },
        {
          id: 5,
          nav: '联系我们'
        }
      ],
      // newsList: [
      //   {
      //     id: 16,
      //     imgUrl: require('./21-0623-cover.jpg'),
      //     date: '2021年06月23日',
      //     title: '亚商对话丨张琼女士受邀成为新加坡证券交易所SGX首位中国大陆对话者'
      //   },
      //   {
      //     id: 15,
      //     imgUrl: require('./21-0115-cover.jpg'),
      //     date: '2021年01月15日',
      //     title: '亚商荣誉丨亚商资本获融中2020最佳创投机构TOP50，张琼女士获最佳投资人TOP50'
      //   },
      //   {
      //     id: 0,
      //     imgUrl: require('./20-1016-cover.jpeg'),
      //     date: '2020年10月16日',
      //     title: '亚商观点丨创新消费投资处在跑马圈地时期，内功浑厚才能实现长期主义'
      //   },
      //   {
      //     id: 1,
      //     imgUrl: require('./20-0829-detail1.jpeg'),
      //     date: '2020年08月29日',
      //     title: '亚商喜讯丨亚商资本荣获私募股权投资机构价值榜&最受LP认可投资机构'
      //   },
      //   {
      //     id: 2,
      //     imgUrl: require('./20-0827-cover.jpeg'),
      //     date: '2020年08月27日',
      //     title: '亚商喜讯丨亚商连续两年荣获最受创业者欢迎创投机构奖'
      //   },
      //   {
      //     id: 3,
      //     imgUrl: require('./19-0919.jpg'),
      //     date: '2019年09月19日',
      //     title: '亚商喜讯丨2019中国最受创业者欢迎，中国国民新品牌领域最具发现力奖'
      //   },
      //   {
      //     id: 4,
      //     imgUrl: require('./news23-cover.jpg'),
      //     date: '2019年01月23日',
      //     title: '亚商观点丨张琼：投资正当年'
      //   },
      //   {
      //     id: 5,
      //     imgUrl: require('./news21-cover.jpg'),
      //     date: '2019年01月21日',
      //     title: '亚商快讯丨亚商荣获中国最佳创业投资机构TOP50'
      //   },
      //   {
      //     id: 6,
      //     imgUrl: news9cover,
      //     date: '2018年04月19日',
      //     title: '看到更加稳定、更加开放的中国——亚太商业展望会议聚焦中国经济的挑战和机遇'
      //   },
      //   {
      //     id: 7,
      //     imgUrl: news1cover,
      //     date: '2018年4月2日',
      //     title: '亚商大会丨亚布力论坛理事张家港行'
      //   },
      //   {
      //     id: 8,
      //     imgUrl: news2cover,
      //     date: '2018年2月12日',
      //     title: '亚商观点丨张琼：消费升级给中国带来的机会和机遇'
      //   },
      //   {
      //     id: 9,
      //     imgUrl: news3cover,
      //     date: '2018年2月4日',
      //     title: '亚商荣获融资中国2017年度中国创业投资机构TOP50'
      //   },
      //   {
      //     id: 10,
      //     imgUrl: news4cover,
      //     date: '2018年2月5日',
      //     title: '亚商拜年丨活力2018'
      //   },
      //   {
      //     id: 11,
      //     imgUrl: news5cover,
      //     date: '2018年1月17日',
      //     title: '天奥电子首发通过'
      //   },
      //   {
      //     id: 12,
      //     imgUrl: news6cover,
      //     date: '2017年12月12日',
      //     title: '亚商观点丨围绕着13亿人口消费的需求。是最看得见，看得清的方向。'
      //   },
      //   {
      //     id: 13,
      //     imgUrl: news7cover,
      //     date: '2017年10月25日',
      //     title: '亚商小文丨做股权投资必须具备的五种分裂型人格'
      //   },
      //   {
      //     id: 14,
      //     imgUrl: news8cover,
      //     date: '2017年',
      //     title: '深圳亚商创新基金正式成立'
      //   }
      // ],
      newsList: [
        {
          id: 16,
          imgUrl: require('./21-0623-cover.jpg'),
          date: '2021年06月23日',
          tit: '亚商对话丨张琼女士受邀成为新加坡证券交易所SGX首位中国大陆对话者',
          time: '2021-06-23  亚商ABC',
          summary: '',
          content: [
            {
              pic: require('./21-0623-detail1.jpg'),
            },
            {
              text: '北京时间2021年6月15日，由新加坡证券交易中心SGX举办的线上对话Front Seats: Conversations in Global Finance。亚商集团总裁，亚商资本创始合伙人张琼女士作为首位中国大陆的受邀speaker参加了活动。'
            },
            {
              pic: require('./21-0623-detail2.jpg'),
            },
            {
              text: '本次对话在两位资深投资人之间展开，两位投资人就当下投资热点和各自的投资领域展开讨论。亚商在此抢先一步为大家带来本次对话的部分翻译内容。'
            },
            {
              text: '主持人：Loh Boon Chye-新加坡交易所首席执行官'
            },
            {
              text: '对话人：Mark Beeston-Illuminate Financial创始合伙人'
            },
            {
              pic: require('./21-0623-detail3.jpg'),
            },
            {
              text: '张琼女士提到，新冠疫情对中国投资行业的影响是短期的，目前在医疗健康、运动、新创品牌、单身经济和企业服务(2B服务)等行业深受中国投资者的欢迎。投资是要投下一个浪潮和未来。',
            },
            {
              text: '同样这两年受到影响的还有消费者行为——在线消费激增，尤其是在直播电子商务平台上。2020年，这些平台贸易额接近1万亿，中国用户数量达到3.72亿。',
            },
            {
              text: '对于我们投资的公司，我们建议他们更关注现金流和对融资保持积极态度。对于一些有足够现金并看到机会占领市场的公司来说，我们鼓励他们用更低的成本抓住更多的机会。亚商投资的一家在中国经营连锁体育的公司，在许多小企业因为新冠而放弃了租约，该公司抓住这个机会与房东达成低价协议。在2020年底，该公司的业务规模几乎翻了一倍，而且在收入和利润方面都有了大幅增长。这家公司，在封锁期间我们帮助其完善客户关系管理和在线会员服务，如在线商店和在线论坛，与他们的会员、粉丝群持续保持沟通。'
            },
            {
              text: '在对话的最后，张琼女士提到中国投资市场对民族品牌的崛起的乐观态度和扶持。新的品牌，服务，消费环境的营造，对新消费习惯的培养以及出口电商等。更重要的是，她认为现在年轻的创业者不同于以往的第一代创业者，他们受过良好的教育，有国际视野，有新的想法和活力，并有着很强的执行力。他们更懂得年轻的消费群体。带来全新的产品，全新的体验，能让市场与资本为之追逐。他们代表着中国的未来。'
            },
            {
              pic: require('./21-0623-detail4.jpg'),
            },
            {
              text: '<p style="color: #409eff;">•Has COVID changed the way VC firms invest?  Has COVID thrown up anything different in terms of themes, investment challenges, consumer or company behaviour?</p>',
            },
            {
              text: 'Joan Zhang：',
            },
            {
              text: 'The impact from the COVID is for short-term. VC firms supposed to be adaptive to the changing market because investors always need to catch new waves in the future.',
            },
            {
              text: 'As for the COVID, it has changed some of people’s habits, such as work at home. And this change may evolve into a new trend---the high growth of ZOOM’s users in the States. and Tencent Conference in China. Other examples: convenient food and livestream e-commerce.',
            },
            {
              text: 'Currently the industry of healthcare, sports, single economy, fresh food delivery, and business enterprise services(2B service) are definitely popular among the investors in China. And the covid has made these industries more acknowledged and supported by the government and market.',
            },
            {
              text: 'As for consumer behaviors, there is a surge in on-line consumption, especially on the livestream e-commerce platforms. In 2020, the trade volume on these platforms nearly reached 1000 billion, and the users’ quantity has reached 372 million in China.',
            },
            {
              text: 'As for the companies, they are paying more attention to cash flow and ROI rather than the revenue growth.',
            },
            {
              text: 'We would pay attention to their cash flow because when all the business shut down at the beginning of COVID, we were not sure how long would this lockdown last, and the money is the key to survive.',
            },
            {
              text: 'We suggest our portfolio companies to stay positive in financing, including equity financing and bank loans.',
            },
            {
              text: 'And for some specific companies who has enough cash and saw the chance to occupy market, we were fully supportive. One of our portfolio company who is running chain sports center in China, found that many small businesses were giving up their lease because of COVID, and we suggest the company to take the opportunities to reach low-priced agreements with the landlords. In the end of 2020, we found the company nearly doubled its business scale and got a big growth in both revenue and profit.',
            },
            {
              text: 'And for the same company, we help with its CRM and online member services during the lockdown, such as member online-store and online forum, to keep communication with its costumers while they cannot come to the sports center personally.',
            },
            {
              text: '以上部分现场内容，更多精彩对话内容敬请关注后续内容',
            },
          ]
        },
        {
          id: 15,
          imgUrl: require('./21-0115-cover.jpg'),
          date: '2021年01月15日',
          tit: '亚商荣誉丨亚商资本获融中2020最佳创投机构TOP50，张琼女士获最佳投资人TOP50',
          time: '2021-01-15  亚商ABC',
          summary: '',
          content: [
            {
              id: 0,
              text: '穿越一个10年、见证资本变迁。融资中国（第十届）资本年会暨颁奖盛典于2021年1月13日-14日隆重召开，会上正式发布2020年度股权投资领域九大综合榜单。亚商资本也凭借多年积累的实力和2020年优秀的表现，荣登榜单。'
            },
            {
              id: 1,
              text: '<p style="font-weight: bold;text-align: center; color: #ab3737; text-indent: 0;">恭喜亚商资本获得<br>融资中国2020年度<br>中国最佳创业投资机构TOP50</p>',
            },
            {
              id: 2,
              text: '<p style="font-weight: bold;text-align: center; color: #ab3737; text-indent: 0;">恭喜亚商资本创始合伙人张琼女士获得<br>融资中国2020年度<br>中国最佳投资人TOP50</p>',
            },
            {
              id: 3,
              text: '也恭喜一同获奖的股权投资界的精兵强将们，为2020年的投资界带来精彩与活力'
            },
            {
              id: 4,
              pic: aezboRveno
            }
          ]
        },
        {
          id: 14,
          imgUrl: require('./20-1016-cover.jpeg'),
          date: '2020年10月16日',
          tit: '亚商观点丨创新消费投资处在跑马圈地时期，内功浑厚才能实现长期主义',
          time: '2020-10-16  亚商ABC',
          summary: '',
          content: [
            {
              text: '10月12日至15日，由清科集团、投资界主办，华发集团联合主办，珠海市人民政府作为特别支持单位，第二十届中国股权投资年度论坛在珠海顺利举办。本次会上，亚商资本创始合伙人，亚商集团总裁张琼女士作为主场消费圆桌主席主持讨论。'
            },
            {
              text: '数字经济时代，云计算、短视频新技术，新场景，重构了人、货、场的要素关系，为数字行业提供了新的风口，为新的商业的到来提供了很多的机会。'
            },
            {
              text: '<p style="font-weight: bold;">流量与数字，新消费奥力给</p>'
            },
            {
              pic: require('./20-1016-cover.jpeg'),
              imgDetail: ''
            },
            {
              text: '本场新消费圆桌论坛由张琼女士主持，同场参与讨论的有来自硅谷银行企业客户部总经理敖宇翔，德迅投资董事总经理齐海，华映资本主管合伙人王维玮，青锐创投创始合伙人吴斌，璀璨资本管理合伙人吴晓丰，山行资本合伙人朱思行。会上张琼女士以投资二十年来伴随中国整个大消费行业的演变和发展为出发点，结合最近几年消费行为的变化，以及流量，社交媒体，数字化和新品牌的出现，剖析新消费行业的投资方向。'
            },
            {
              text: '<p style="font-weight: bold;">新流量，新渠道，到底给消费行业带来了什么？</p>'
            },
            {
              text: '从消费投资看消费行业，消费是一个准入门槛非常低的行业，<span style="font-weight: bold;">这就是消费为什么很容易起来，但是又是一个很难建立壁垒的行业。</span>'
            },
            {
              text: '中国作为全球供应链的中心，做一个产品，从0到1并不难，但从0到1还谈不上品牌。真正建立一个品牌要经过三个阶段:'
            },
            {
              text: '第一就是货要卖出去。流量其实是起到了第一步的作用，怎么把产品能够卖出去。但不是说卖出去的就是品牌，哪怕卖了几千万，也还成不了品牌。'
            },
            {
              text: '第二个阶段是渠道品牌，国际上有一个新的做品牌的趋势叫做DTC。但是哪怕是DTC，第一步也是直销，直接卖给消费者。而要从一个亿到五亿，十个亿到三十个亿，还是要通过渠道。利用适合的所有的渠道商，包括淘宝、天猫、京东、抖音，还有其他的社交媒体的渠道，规模就可以上去。'
            },
            {
              text: '最后真正要做的就是消费者品牌，这个过程大概需要几年的时间去沉淀去坚持，但是最终实现的是品牌占据消费者的心智。'
            },
            {
              text: '从这些角度来讲，渠道会变，流量会变，这些只是可以利用的工具。'
            },
            {
              pic: require('./20-1016-detail.jpeg'),
              imgDetail: ''
            },
            {
              text: '<p style="font-weight: bold;">消费者对世界认识的不同，会对消费产生什么样的改变？</p>'
            },
            {
              text: '关于这个问题，<span style="font-weight: bold;">张琼女士定义消费是一个长期主义。</span>'
            },
            {
              text: '消费是一个大框，包罗万象。中国现在的消费行业还是非常年轻，非常初级的。在中国这么大的一个消费体量下面，会在未来会成长出类似于国际上的这些大的消费品集团，但是这些大的消费品集团，美妆行业的欧莱雅，食品行业的达能，还有联合利华，雀巢，其实他们都是从一个点开始，然后通过不断的收购兼并，不断的壮大，从一个市场做到另外一个市场，然后全球化，才能真正形成一个大的消费王国。'
            },
            {
              text: '所以中国的消费品行业还有很长的一段路要走，但是人是非常重要的。消费品行业不是以技术作为门槛，说到底就是做人的生意。'
            },
            {
              text: '讨论中还提到，新生代对消费趋势的影响，即所谓精神属性的消费品，传统意义上的电影、音乐和游戏，可能是纯精神属性，精神属性的东西，结合了现在物质属性的消费品，包括泡泡玛特，还有和宠物有关的，这些新生态在引领传统消费的观点，他们没有经历过物质匮乏，没有经历过国货和进口货巨大的差异，反而他们对精神属性需求的追求是井喷式的爆发，追求自我实现，追求美，追求健康，追求社交属性的产品，只要是精神属性和物质属性结合得比较好的消费品，毫无疑问是可以反过来引领消费者的。'
            },
            {
              text: '<p style="font-weight: bold;">现在对整个新的消费创业企业来讲，是一个跑马圈地的时候，谁能够最后跑出来，一要看谁能抓住市场先机、消费新人群需求的同时又能练好内功。</p>'
            },
          ]
        },
        {
          id: 13,
          imgUrl: require('./20-0829-detail1.jpeg'),
          date: '2020年08月29日',
          tit: '亚商喜讯丨亚商资本荣获私募股权投资机构价值榜&最受LP认可投资机构',
          time: '2020-08-29  亚商ABC',
          summary: '',
          content: [
            {
              text: '8月27日，第一财经和36氪，一个沉淀多年的资深金融媒体，一个年轻朝气的开创性平台。齐聚上海浦东，点燃行业的盛宴。'
            },
            {
              text: '在这次的评比中，亚商资本一共斩获了3项荣誉，分别是：'
            },
            {
              text: '<p style="font-weight: bold;text-align: center; color: #CC6600; text-indent: 0;">36氪2020年度<br>中国最受创业者欢迎创业投资机构TOP100<br>中国最受LP认可创业投资机构TOP50</p>'
            },
            {
              pic: require('./20-0827-cover.jpeg'),
              imgDetail: ''
            },
            {
              pic: require('./20-0829-detail1.jpeg'),
              imgDetail: ''
            },
            {
              text: '<p style="font-weight: bold;text-align: center; color: #CC6600;text-indent: 0;">第一财经2020年度<br>私募股权投资机构TOP50</p>'
            },
            {
              pic: require('./20-0829-detail2.jpeg'),
              imgDetail: ''
            },
            {
              text: '荣誉多，伴随而来的是肩负的责任。'
            },
            {
              text: '再次感谢第一财经和36氪对创投机构和创投公司的持续关注，亚商也会继续永葆初心，做创业者可靠的伙伴！'
            },
            {
              text: '投资是一种陪伴 一种力量。'
            },
          ]
        },
        {
          id: 12,
          imgUrl: require('./20-0827-cover.jpeg'),
          date: '2020年08月27日',
          tit: '亚商喜讯丨亚商连续两年荣获最受创业者欢迎创投机构奖',
          time: '2020-08-27  亚商ABC',
          summary: '',
          content: [
            {
              text: '这是难以言表的一年'
            },
            {
              text: '人们曾悲观地为2020设想过许多令人沮丧的关键词。但时至夏末，我们却惊异地发现，这个戏剧性的年份非但不是我们想象中的消极景象，医疗健康、企业服务、消费品牌、高端制造等领域，都涌现出了一批极富生命力的创业者，资本的加注也一如既往的活跃。创业者也在为自己心目中最强力，最优秀的投资者打分~'
            },
            {
              text: '<p style="font-weight: bold;">由于疫情的种种影响，由36氪主办的2020年度WISE超级进化者大会姗姗来迟。但是好饭不怕晚，本届会上36氪的数据榜单的颁布，亚商连续两年入围并获得：</p>'
            },
            {
              pic: require('./20-0827-cover.jpeg'),
              imgDetail: ''
            },
            {
              text: '感谢36氪对创投机构和创投公司的持续关注，亚商也会继续永葆初心，做创业者可靠的伙伴！'
            },
            {
              pic: require('./20-0827-detail.jpeg'),
              imgDetail: ''
            },
            {
              text: '我们一直相信投资是一种陪伴，一种力量。'
            },
          ]
        },
        {
          id: 11,
          imgUrl: require('./19-0919.jpg'),
          date: '2019年09月19日',
          tit: '亚商喜讯丨2019中国最受创业者欢迎，中国国民新品牌领域最具发现力奖',
          time: '2019-09-19  亚商ABC',
          summary: '',
          content: [
            {
              text: '9月17日18日，还未入秋的深圳，在新地标深圳湾，36氪投资人未来峰会上。亚商又收获两“块”沉甸甸的奖“砖”。'
            },
            {
              pic: require('./19-0919_1.jpg'),
              imgDetail: ''
            },
            {
              text: '<p style="text-align: center">本次榜单，亚商荣获两大行业奖项</p>'
            },
            {
              pic: require('./19-0919_2.jpg'),
              imgDetail: ''
            },
            // {
            //   text: '<p style="text-align: center; margin: 20px 0 10px 0;"><span style="padding: 2px 20px; background-color: #9AB1F9; color: #fff;">风风雨雨20年</span></p>'
            // },
            {
              text: '<p style="text-align: center">亚商资本作为投资界的老兵，年方二十，必须保持活力，逆生长地稳步前行。</p>'
            }
          ]
        },
        {
          id: 10,
          imgUrl: require('./news23-cover.jpg'),
          date: '2019年01月23日',
          tit: '亚商观点丨张琼：投资正当年',
          time: '2019-01-23  亚商ABC',
          summary: '',
          content: [
            {
              text: '2019年1月15日-18日，融资中国2019（第八届）资本年会隆重召开。亚商集团总裁，亚商资本创始合伙人张琼女士在中国股权投资年度峰会的开篇，为与会嘉宾同道们带来了一场关于<span style="font-weight: bold;">理性投资的感性分享。</span>'
            },
            {
              pic: require('./news23-1.jpg'),
              imgDetail: ''
            },
            {
              text: ' 以下为现场实录整理<div style="font-weight: bold; text-indent: 2em;">在这跟大家分享一下我即做创业者，又做投资人这么多年的三个感悟。</div>'
            },
            {
              text: '<p style="text-align: center; margin: 20px 0 10px 0;"><span style="padding: 2px 20px; background-color: #9AB1F9; color: #fff;">风风雨雨20年</span></p>'
            },
            {
              text: '中国股权投资发展到现在二十年，第一个基金深创投1999年成立，到今年正好是20年。这二十年其实是风风雨雨，跌宕起伏的。现在面临的困难和挑战，其实是很正常的。任何一个市场，任何一个经济在发展中都会有周期。这20年间我们遇到过的坎，如2001年创业板搁置，那个时候正好在美国泡沫破裂的时候；2005年至2009年股权分置改革IPO叫停。下一个市场高峰来临的时候——2009年IPO重启，如果你在2005年、2006年前后做了一批投资，这个2009年恰恰是你回报的时候，亚商也正是在2006年的时候投了福建圣农，一家专注于养鸡的公司，中间IPO就停了，2009年IPO重开它就顺利上市了，公司是龙头企业，经营好，这个项目我们就获得了三十倍的回报。在市场不好的时候投进去，当市场好的时候那可能就是收割的黄金时候。'
            },
            {
              text: '股权投资这个行业在中国就像是年轻人刚刚从大学毕业的时候，二十年风华正茂。之前求学的过程中会碰到各种各样的困难，但是学到了很多。现在你开始慢慢变的成熟，而这个时候你从大学来到社会，整体社会经济形势不太好，就业形势不太好，没关系我们还是有很多的时间去学习，去历练，寻找到合适自己发展的方向。'
            },
            {
              pic: require('./news23-2.jpg'),
              imgDetail: ''
            },
            {
              text: '<p style="text-align: center;"><span style="padding: 2px 20px; background-color: #9AB1F9; color: #fff;">修炼内功</span></p>'
            },
            {
              text: '现在正好是我们整个行业处于专业化、机构化、特色化的过程。出现大量的CVC，整个LP出资人越来越机构化，越来越多出现了特色基金，并购基金，家族基金，还有一些精品化基金、定制产业基金。'
            },
            {
              text: '不管外部市场怎么样，但是对我们投资人来讲永远最重要的就是练好我们的内功，我们要更专注，我们更需要有一个全局观，更要有特色，未来投资的点在哪，今天确实很难讲，每一次科技进步之后会对整个未来企业的创新，商业模式的创新和技术应用创新带来前所未有的革命。'
            },
            {
              text: '大家现在都在说AI，AI出来会创造什么新的东西？去年夏天我在硅谷看了一个项目，他本来就是做汉堡的餐厅，但是他利用整个AI和传感器的技术，做了一套封闭式的机器人的系统去做汉堡包，最后他们得出的结论：这样做汉堡包效率更高、口感会更好。类似于这样的技术出来之后，它可能对我们消费层面，企业的模式都会带来一种革命性的改变，现在我们做投资我们要更有一个全局，更要往前看，看一看未来五年这样的技术可能会对某些产业带来的革命性改变。'
            },
            {
              text: '再说到中国的三四线城市。从2015年以后整个消费增长在一二线城市已经呈现了下跌的趋势，在三四线城市虽然它也有下跌，但是它整个下跌的幅度要远远低于一二线城市，从这个角度来看我们整个消费在往三四线城市的延伸。在未来二到三年中会是非常大的市场，对我们投资的企业来说，现在你的店都是开在一二线城市，但是需要把你的产品重新定位，快速延展到三四线城市，抓住那里的市场。'
            },
            {
              text: '还有一个就是出海。刚才也有投资人提到，中国一直是一个出口大国，但是中国以前的出口大家觉得就是一个代工的概念。但是我相信在未来五到十年中国产品的出海一定是有自有品牌的，高性价比，产品力是非常强的出海，包括我们的服务。现在像互联网企业都已经进入东南亚，马来西亚，印度尼西亚，印度，已经在那里布局，把中国的模式搬过去。'
            },
            {
              text: '做一个创业企业不容易，消费品类来讲它的时间跨度更大。GAP，优衣库，星巴克，都是在六七十年代成立的，都是二战后经济复苏成长起来的一批，当时他们每一家都有自己特殊的定义，譬如GAP当时首创了SPA概念，自己生产的产品通过自己开零售店销售，首创了新的商业模式。优衣库也是一样的，1963年成立，那也是日本经济正好进入好最黄金的时间段。优衣库做了很多自我研发，面料是他自己研发出来的，从产品线、营销模式才能走出今天的优衣库。未来在中国一定会出来这样具有非常强的品牌力，它有很强的技术驱动，又是全营销体系线上线下社交媒体，把品牌、营销、技术能够完整整合在一起，这个是谁现在我们还不知道，谁能走出来，这是一个漫长的过程，作为投资人来讲，我们可能只是陪伴他们中间其中的某一些阶段。'
            },
            {
              text: '<p style="text-align: center;"><span style="padding: 2px 20px; background-color: #9AB1F9; color: #fff;">投资就是投人</span></p>'
            },
            {
              text: '最后我想分享的一点，大家都在说产业，练内功，做了这么多年的投资人，我还是非常坚信一点：投资就是投人。尤其是在前途不是那么清晰的时候。所有的创业者可能都是不一样的，都是各有各的特色，各有各的个性，各有各的背景，真正会成功的创业者一定具备这三个要素，就像谁能够把一个派做的足够大：'
            },
            {
              text: '<span style="font-weight: bold;">首先要有Passion，</span>'
            },
            {
              text: '<span style="font-weight: bold;">第二要有Integrity，</span>正直、理性、同理心的创业者，这一点在今天经济发展不是很明朗，创业道路很艰难的时候是一个创业者更要坚守的底线，也是我们投资人看创业者是非常重要的一点。'
            },
            {
              text: '在2018年曾经有一本书非常火，讲的是在硅谷创业者Elizabeth Holmes，30岁非常成功，她创了一个公司叫做Theranos，用一滴血就可以检验出你身上很多的指标，最后大家知道这就是一个骗局。她也算是我斯坦福的校友。我离开的时候她正好进学校，我们不在一个学院，我相信在她最初想创立这个公司的时候并不是想要骗人的，最后她把这个故事越说越大。她实现不了的时候她做了一个选择维持现状，用更多的故事去骗更多的投资。创业有成功有失败很正常，作为创业者、包括我们做投资人，在自我的实现之外，我们也要考虑到对社会的责任、对员工、投资人以及所有利益相关方的责任。'
            },
            {
              text: '<span style="font-weight: bold;">最后是Execution，</span>你需要有非常强的执行力。从零到一很难，从一到十更有挑战，更难，所以你超强的执行力现在就变的越来越重要。'
            },
            {
              text: '在哈利波特里边邓布利多校长说过的一句话：当黑暗在前面的时候，那可能就是要我们做选择的时候，这个时候你是选择The right way, or the easy way。选择可能没有对错，有些选择眼前看来是很容易的，走下去可能就是一个错误，有些选择现在看起来很难，但是它走下去方向是对的，那你怎么样去做这个选择。'
            },
            {
              pic: require('./news23-3.jpg'),
              imgDetail: ''
            },
            {
              text: '现场大部分都是投资人，我要恭喜大家，我觉得做投资人是非常好的，你说它是职业也好，我觉得它更是生活方式。我们永远要对创业者表达敬意，因为创业者是真正驾驭创业这匹快马的骑马士，他承担了更多的责任。对投资人来讲，从一种生活方式或者是职业来讲，我觉得是世界上最棒的。因为你不断面临新的未知的东西，你永远保持挑战，永远保持一种新鲜，但同时你又可以学到很多的东西，交到非常多的朋友，你做上了投资人之后就不想离开它，哪怕面临困境我们也要坚持下去，最后预祝大家在2019年和未来都成为一个快乐的人，成为一个健康的人，最后最重要是要成为一个有趣的人。'
            }
          ]
        },
        {
          id: 9,
          imgUrl: require('./news21-cover.jpg'),
          date: '2019年01月21日',
          tit: '亚商快讯丨亚商荣获中国最佳创业投资机构TOP50',
          time: '2019-01-21  亚商ABC',
          summary: '',
          content: [
            {
              text: '2019年1月15日-18日，融资中国2019（第八届） 资本年会隆重召开，在会上正式颁布了2018年度股权投资领域10大综合榜单。有18年创投历程的亚商资本，在本次评选中也有所收获，在两个不同维度的排行榜中斩获荣誉。这也是对亚商资本18年工作的肯定和鼓励。'
            },
            {
              text: '<p style="text-align: center; font-size: 20px"><span style="font-weight: bold;">亚商资本荣获</span>融资中国2018年度<span style="font-weight: bold;">中国最佳创业投资机构TOP50</span></p>'
            },
            {
              pic: require('./news21-1.jpg'),
              imgDetail: ''
            },
            {
              pic: require('./news21-2.jpg'),
              imgDetail: ''
            },
            {
              text: '<p style="text-align: center;font-size: 20px"><span style="font-weight: bold;">亚商资本荣获</span>融资中国2018年度<span style="font-weight: bold;">最佳投后管理股权投资机构TOP10</span></p>'
            },
            {
              pic: require('./news21-3.jpg'),
              imgDetail: ''
            }
          ]
        },
        {
          id: 8,
          imgUrl: news9cover,
          date: '2018年04月19日',
          tit: '看到更加稳定、更加开放的中国——亚太商业展望会议聚焦中国经济的挑战和机遇',
          time: '2018-04-19  亚商ABC',
          summary: '',
          content: [
            {
              id: 0,
              pic: news9cover,
              imgDetail: '陈琦伟教授在研讨会上 （图片来源：侨报记者夏嘉摄）'
            },
            {
              id: 1,
              text: '在洛杉矶市中心4月16日举办的第31届亚太商业展望会议上，来自亚太地区和美国的学界、商界以及政界代表再一次将目光集中在了亚太地区，尤其是中国的经济发展上，中国的经济改革和贸易问题则成为本次会议讨论的焦点。'
            },
            {
              id: 2,
              text: ' 由南加州大学马歇尔商业学院（Marshall School of Business）和美国商务服务部（U.S. Commercial Service）共同举办的第31届亚太商业展望会议周一在洛杉矶市中心万豪酒店（LA Grand Hotel）举行，活动汇集了50多位学界、商界和政府代表来讨论亚太地区的贸易和投资。前美国驻中国大使骆家辉（Gary Locke）为大会进行了名为《改变中的中国社会》的主题演讲，讨论美中贸易以及中国社会面临的挑战和机遇等。'
            },
            {
              id: 3,
              text: '中国成为这次会议的重中之重，包括美国驻中国使馆的高级商务官员格里芬（Cynthia Griffin）在内的美国政府官员对中国的经济的现状和未来进行了分析，包括中国创业资本研究中心主任陈琦伟教授、哈佛亚洲中心高级研究员奥维尔霍特（William Overholt）在内的中美学者也对中国经济所面临的挑战和机遇作出了深度的剖析。'
            },
            {
              id: 4,
              text: '中国创业资本研究中心主任，亚商集团董事长陈琦伟教授在谈到中国的经济现状时指出，在过去40年中，中国的领导层在决定加入WTO、发展监管权威机构、鼓励创业以及年轻一代创新的政策上作出了正确的判断。现在中国决策者已经意识到世界市场已经不像从前，出口面临的阻力越来越大，中国应该集中精力发展本国的市场。'
            },
            {
              id: 5,
              text: '陈琦伟教授认为，尽管中国的未来面临很多挑战，但是绝大部分的中国人都希望看到更加稳定、更加开放的中国。'
            },
            {
              id: 5,
              text: '亚太商业展望会议主要放眼亚太不同国家和地区的经济和贸易发展现况，经济专家和贸易问题方面的学者和政府官员对其发展进行分析和展望，为致力于亚美贸易的企业、商家提供相关的信息和政策咨询。这次会议探讨的主题包括美国与亚太地区的贸易挑战、政策变化对贸易的影响等，会议还针对中国、日本、泰国、印度尼西亚、越南、新加坡、新西兰和澳大利亚等不同的国家和地区举办小组讨论。'
            },
            {
              id: 5,
              text: '【侨报记者夏嘉4月16日洛杉矶报道】'
            }
          ]
        },
        {
          id: 7,
          imgUrl: news1cover,
          date: '2018年4月2日',
          tit: '亚商大会 | 亚布力论坛理事张家港行',
          time: '2018-04-02  亚商ABC',
          hot: '热点',
          summary: '三月的张家港，花团似锦，春意盎然！3月30日，由亚商资本牵头联合主办的，以“新时代苏南模式升级创新”为主题的亚布力论坛理事张家港行暨第四届“港城合伙人”峰会在美丽的暨阳湖畔--产业资本中心隆重举行。',
          content: [
            {
              id: 0,
              text: '活动邀请到40余位亚布力论坛理事代表及国内知名企业家代表，以及张家港市上市企业、新三板挂牌企业、创新创业企业的优秀企业家代表，共300余位来宾出席。张家港市市委书记朱立凡,市委副书记、市长黄戟出席了活动。'
            },
            {
              id: 1,
              pic: detail1
            },
            {
              id: 2,
              text: '市委书记朱立凡在致辞中对活动的举办表示了热烈欢迎'
            },
            {
              id: 3,
              pic: detail2
            },
            {
              id: 4,
              text: '围绕“新时代苏南模式升级创新”主题，亚布力论坛原名誉主席刘明康, 全国人大财经委员会原副主任委员、重庆市原市长黄奇帆，康得投资集团、康得新集团董事长钟玉、汉德资本主席蔡洪平，赛富亚洲投资基金创始管理合伙人阎焱，道同资本创始合伙人张醒生，长江润发董事长郁霞秋，张家港农商银行董事长季颖等8位重量级嘉宾进行了精彩的主题演讲，解读时势热点和趋势，碰撞思想智慧和火花，提升资本战略视野，明晰转型发展之路。'
            },
            {
              id: 5,
              text: '在“港城合伙人”结对环节，包括康得新复合材料集团股份有限公司、江苏国泰国际集团国贸股份有限公司、江苏张家港农村商业银行股份有限公司、长江润发医药股份有限公司在内的10家张家港上市企业，与上海亚商发展集团有限公司、汉德资本、赛富亚洲投资基金等亚布力论坛理事企业成功牵手，跨出了“港城合伙人”打造区域性影响力和专业性的资本创新发展交流平台的第一步。'
            },
            {
              id: 6,
              pic: detail3
            },
            {
              id: 7,
              text: '此外，《张家港市上市公司与资本市场白皮书》在峰会上进行了发布。最后亚商集团董事长陈琦伟进行了总结致辞。'
            },
            {
              id: 8,
              pic: detail4
            }
          ]
        },
        {
          id: 6,
          imgUrl: news2cover,
          date: '2018年2月12日',
          tit: '亚商观点丨张琼：消费升级给中国带来的机会和机遇 亚布力论坛理事张家港行',
          time: '2018-02-12  亚商ABC',
          summary: '2018年1月31日至2月2日，融资中国2018（第七届）资本年会在北京四季酒店隆重举行，来自政府、金融机构、投融资机构、第三方财富管理、以及上市公司、风口企业齐聚一堂，共同探讨新时代背景下的股权投资行业趋势和方略。',
          content: [
            {
              id: 0,
              text: '在2月1日的峰会上，亚商资本创始合伙人、总裁张琼发表了主旨演讲，他从亚商资本在消费领域的投资布局的发展历程和经验，讲述了中国大消费行业的发展变迁以及消费升级给中国带来的机会和机遇。'
            },
            {
              id: 1,
              pic: img2
            },
            {
              id: 2,
              text: '（以下为亚商资本创始合伙人、总裁张琼的主旨演讲实录。）'
            },
            {
              id: 3,
              text: '大家上午好，感谢融资中国，感谢朱闪董事长给我们提供的这次机会。'
            },
            {
              id: 4,
              text: '这次来北京让我躲过了上海的雾霾，2017年北京天气出奇的好，这有点像投资，有时候你不知道下一个变化会在哪里。'
            },
            {
              id: 5,
              text: '来北京的前一天我们举办了亚商资本的年会，正好把一些思考和大家做一个分享。'
            },
            {
              id: 6,
              text: '最近有一部电影《无问西东》，其中有一句话让我很有感触，“你看到了什么，你在做什么。在这个过程中间，如果你觉得不是懊悔，也不羞耻，有一种非常平和的喜悦，这就是真心。”我想这次大会的主题是“大潮起”，潮起、潮落——在这样比较纷繁、焦躁的时代，无论投资也好，创业也好，或者你什么事情都不做，最重要的是保持平和开心，这非常重要，这样你才可以不迷失方向。'
            },
            {
              id: 7,
              text: '第二，很多嘉宾刚才都提到最近很火的区块链。去年夏天，我在旧金山和张首晟教授偶遇，他是斯坦福大学物理系、电子工程系和应用物理系终身教授，向他请教区块链的问题，他认为区块链是未来的革命，区块链带来的最重要价值是突破性的价值互换。'
            },
            {
              id: 8,
              text: '中国有一句话叫分久必合，合久必分，互联网大平台让大家集中起来，我们可以通过谷歌和百度搜索到任何想搜索到的东西，但是有了区块链技术以后，每个人不需要大平台就可以获得你想要的东西，甚至可以进行价值的互换，也许未来的互联网革命就是合久必分。'
            },
            {
              id: 9,
              text: '今年是亚商资本18岁的成人礼了，亚商资本是中国资本市场创投行业最早成立的一批民营机构。十几年来我们战战兢兢如履薄冰，但很欣慰的是，我们一直在做自己熟悉和喜欢的事情。亚商资本刚成立的时候，创业投资在中国还是新概念，所以我们当时问自己，我们能做什么？能投什么？看得懂什么？当时定了一个现在回想起来不算是策略的策略，那就是和中国13亿人口消费需求有关的投资方向。'
            },
            {
              id: 10,
              text: '亚商资本的第一只基金2001年成立，现在已经投了一百多个项目，这个投资个数不算多，因为我们一直是小步快跑，保持节奏，不急躁也不激进。这其中已经有34个项目通过IPO、并购退出。所以我觉得投资还是要投自己熟悉行业，保持自己的节奏，这点非常重要。'
            },
            {
              id: 11,
              text: '最近大家都在谈消费升级的概念，大家都认为消费升级是大市场、大趋势，其中有非常多的投资机会。其实，我认为十几年以来，消费升级在中国一直都是主旋律。我们在过去经历了三次消费升级，第一次应该是从九十年代中期开始，中国经历了一代消费品生产规模化和品牌化的过程。在那个时候我们投资了圣农集团，双汇集团。那个时候出现了一批消费品领域的品牌，牛奶行业，酸奶行业，水行业，这是中国第一次消费升级。'
            },
            {
              id: 12,
              text: '包括类似像7天酒店的投资，是很早期的创业性投资。7天最初四个股东，当时没有人投资经济性连锁品牌。那个时候最多的是招待所，所以这时候我们觉得中国应该出现一个不是那么贵的，但是有品牌、标准化、放心住、干净的酒店，当时就决定投资7天酒店。7天酒店成立于2005年初，2015年卖给锦江集团，有亚商注册资本6千万，卖给锦江集团估值是一百个亿。'
            },
            {
              id: 13,
              text: '最近大家都在谈消费升级的概念，大家都认为消费升级是大市场、大趋势，其中有非常多的投资机会。其实，我认为十几年以来，消费升级在中国一直都是主旋律。我们在过去经历了三次消费升级，第一次应该是从九十年代中期开始，中国经历了一代消费品生产规模化和品牌化的过程。在那个时候我们投资了圣农集团，双汇集团。那个时候出现了一批消费品领域的品牌，牛奶行业，酸奶行业，水行业，这是中国第一次消费升级。'
            },
            {
              id: 14,
              text: '第二次消费浪潮就是渠道的变革和渠道的创新。电商联手渠道，比如联手超市，便利店，而且专业性垂直连锁平台风起云涌。在那个时候我们投资了丽家宝贝，和东方时尚驾校等等。'
            },
            {
              id: 15,
              text: '第三次消费升级就是现在的时代。我们可以投资淘品牌，Miss Candy在细分领域做到了淘品牌的第一，我觉得互联网对新品牌创立最大的优势是，创立比较快、门槛比较低。但是存在的问题就是忠诚度是非常低，所以在建立品牌的时候一定要从线上走到线下。淘品牌在线下开了30多个店，线上线下联动起来已经开始盈利。'
            },
            {
              id: 16,
              text: '另外我们还投了洛克公园，也投了游戏公司、互联网医疗平台等，这些都代表未来消费新的趋势。我觉得第三次消费升级的浪潮更强调的是品牌、渠道，背后是创新生活方式的一种融合。'
            },
            {
              id: 17,
              text: '最近达沃斯论坛召开，财经领导小组主任刘鹤做了主题发言，他说2016年是中国新中产消费元年，中国有9.4亿城市人口，接近4亿的新中产人群，这些人群意味着什么？意味着大量的还未爆发出来的消费能力。数据显示，从2000-2018年整个零售市场取得了非常快的增长。有专家预测到了2018年或者2019年中国零售市场总额一定会超过美国。'
            },
            {
              id: 18,
              text: '回到我们今天讨论的主题，未来在哪里？如果投资创新消费，我们应该怎么去看未来的机会在哪里？我觉得未来可能有这么几个关键词，新品牌、新零售、新技术，还有融合跨界、健康快乐、“她经济”。我觉得未来的创新消费，这些是其中非常重要的一些关键词。'
            },
            {
              id: 19,
              text: '很多投资人都在讲技术，大家认为技术变革带来创新机会。但是我一直觉得，我们作为人要消费，要快乐，要健康，要出去玩，不能天天只讲技术，技术应该是背后支撑这些新品牌、新零售、新模式、新生活方式的工具。所以我们还是觉得未来如何发展，中国一定会出现大的消费品牌。就像美国经济高速发展的时候，出现了很多消费品牌，比如星巴克。未来的中国也会出现类似这样的品牌。类似像“喜茶”，是中国自身产生的新品牌，空间肯定非常大。中国的90后00后年轻消费群体的品牌慢慢就会出现，这些品牌往往可能和新的消费渠道，新的消费模式结合在一起。'
            },
            {
              id: 20,
              text: '第二，健康和快乐是我们一直在关注的板块。因为，我觉得消费第一层级是满足温饱，温饱之后需要更多的精神消费。你可能要关注健康，关注快乐，尤其在健康领域去年健身房融资非常热，将来所有的健身模式还会继续做一个融合。'
            },
            {
              id: 21,
              text: '跨界和融合同样非常重要。比如最近星巴克在上海开了一家精品烘焙工厂，每天十点开放，需要排队才能进去。所以星巴克除了咖啡还需要做创新和融合。我相信在中国也会出现类似这样的商业模式和这样的品牌。盒马鲜生也在做这样的尝试，虽然盒马鲜生外卖系统做的不错，但是从整个店面的呈现和布置，我觉得离真正抓住消费者的零售品牌和场景，可能还有很长的路要走。'
            },
            {
              id: 22,
              text: '“她经济”，未来社会女性作为一个群体独立意识的崛起，会带动很大一波消费。更何况女性还是家庭的核心，所以家庭整个消费开支相当一部分是由女性决定的。围绕这些消费，“她经济”会带来广大的消费市场。但是，要了解“她经济”就要了解女性，了解她们的行为习惯，她们的思维，她们的圈子，这样才能够把产品和服务更好的送达到她们的手里。所以，面对未来，这些关键词就是我们投资布局非常重要的核心点。'
            },
            {
              id: 23,
              text: '当然，大家都知道消费品牌的成长很艰难，不像一个技术如果一旦突破，它可能就是几何基数的增长。消费品牌需要一点一滴的积累，任何一个错误可能就会把这个品牌毁掉。所以，我们在做消费投资布局的时候，更多采用矩阵式布局。在消费板块里边进行上下游价值链整体布局，这样才能使我们的投资企业之间产生更多的联合和互动，使我们投资价值更大体现。另外，就是要注重和消费行业的龙头合作，龙头企业会占据更多的渠道和消费者。但是龙头企业也要成长，所以需要不断的收购新品牌，开拓新疆土。'
            },
            {
              id: 24,
              text: '投资的本质是认知的变现，关注你身边熟悉的东西，一样可以找到很多投资机会。'
            },
            {
              id: 25,
              text: '前几天，清华大学副校长在一个论坛上说的两句话让我印象非常深刻，35亿年前，我们所有的人类都是由同一个受精卵发展起来，所以大家返回35亿年前都是同一个人。我们现在对这个世界的认知只有5%，一千年前我们不知道空气，不知道量子。两百年前我们不知道基因。所以，世界如此之大，作为一个人就应该快乐的生活，快乐的存在，做自己喜欢和能够做的事情。'
            },
            {
              id: 26,
              text: '最后一句话，让我们拥抱创新消费时代的到来，祝大家新年快乐，健健康康，谢谢。'
            }
          ]
        },
        {
          id: 5,
          imgUrl: news3cover,
          date: '2018年2月4日',
          tit: '亚商荣获融资中国2017年度中国创业投资机构TOP50',
          time: '2018-02-04  亚商ABC',
          summary: '2018年1月31日至2018年2月2日，“融资中国2018（第七届）资本年会暨颁奖盛典”在北京四季酒店盛大召开。现场除了有精彩纷呈的嘉宾互动，更大的重头戏是揭晓了融资中国2017年度“股权投资榜单”。',
          content: [
            {
              id: 0,
              text: '亚商资本荣获'
            },
            {
              id: 1,
              text: '融资中国2017年度中国创业投资机构TOP50！'
            },
            {
              id: 2,
              text: '下面是融资中国2017年度中国创业投资机构TOP100中50强榜单，亚商资本位居NO.37：'
            },
            {
              id: 3,
              pic: news3detail1
            },
            {
              id: 4,
              pic: news3detail2
            },
            {
              id: 5,
              text: '亚商资本，再创佳绩。'
            }
          ]
        },
        {
          id: 4,
          imgUrl: news4cover,
          date: '2018年2月5日',
          tit: '亚商拜年丨活力2018',
          time: '2018-02-05  亚商ABC',
          summary: '',
          content: [
            {
              id: 0,
              pic: news4detail1
            },
            {
              id: 1,
              text: '亚商的年会'
            },
            {
              id: 2,
              text: '不同于每年5月份高大上亮堂堂的投资策略大会'
            },
            {
              id: 3,
              text: '亚商的年会'
            },
            {
              id: 4,
              text: '更多的是亚商人欢聚一堂'
            },
            {
              id: 5,
              text: '亚商的年会'
            },
            {
              id: 6,
              text: '嘻嘻哈哈没大没小打闹一个晚上~'
            },
            {
              id: 7,
              pic: news4detail2
            },
            {
              id: 8,
              text: '平时专业严肃的合伙人'
            },
            {
              id: 9,
              text: '在年会上可以来一段rap'
            },
            {
              id: 10,
              text: '大金链子戴起来'
            },
            {
              id: 11,
              pic: news4detail3
            },
            {
              id: 12,
              text: '筹光交错'
            },
            {
              id: 13,
              text: '游戏热烈'
            },
            {
              id: 14,
              text: '高歌合唱'
            },
            {
              id: 15,
              pic: news4detail4
            },
            {
              id: 16,
              text: '我们最想的'
            },
            {
              id: 17,
              text: '还是衷心地祝福'
            },
            {
              id: 18,
              text: '亚商的朋友们'
            },
            {
              id: 19,
              text: '亚商的投资人们'
            },
            {
              id: 20,
              text: '亚商的被投企业们'
            },
            {
              id: 21,
              text: '亚商周边所有可爱的人们'
            },
            {
              id: 22,
              text: '在将要来到的新年里'
            },
            {
              id: 23,
              text: '幸福安康'
            },
            {
              id: 24,
              pic: news4detail5
            }
          ]
        },
        {
          id: 3,
          imgUrl: news5cover,
          date: '2018年1月17日',
          tit: '天奥电子首发通过',
          time: '2018-01-17  亚商ABC',
          summary: '',
          content: [
            {
              id: 0,
              text: '鼓掌！'
            },
            {
              id: 1,
              text: '恭喜成都亚商新兴的项目'
            },
            {
              id: 2,
              text: '成都天奥电子股份有限公司'
            },
            {
              id: 3,
              text: '于2018年1月17日'
            },
            {
              id: 4,
              text: '首发获通过'
            },
            {
              id: 5,
              pic: news5detail1
            },
            {
              id: 6,
              text: '成都天奥电子股份有限公司成立于2004年1月，现有员工500余人。公司拥有国家认定企业技术中心，是高新技术企业，主要从事时间频率、北斗卫星应用产品的研发、生产、销售和服务。'
            },
            {
              id: 7,
              text: '主要产品应用于航空航天、卫星导航、军民用通信及国防装备等领域，参加了载人航天、探月工程、北斗卫星导航系统等国家重大工程。'
            }
          ]
        },
        {
          id: 2,
          imgUrl: news6cover,
          date: '2017年12月12日',
          tit: '亚商观点丨围绕着13亿人口消费的需求。是最看得见，看得清的方向。亚布力论坛理事张家港行',
          time: '2017-12-12  亚商ABC',
          summary: '',
          content: [
            {
              id: 0,
              text: '亚商集团联席总裁，亚商资本创始合伙人张琼女士出席清科2017年中国股权投资年度论坛，并就过去30年中国迎来的三波消费升级，如何布局“衣食住行”这盘生意发表观点。'
            },
            {
              id: 1,
              pic: news6detail1
            },
            {
              id: 2,
              text: '像亚商一样，作为中国股权投资的老兵，最早期就活跃在股权投资市场上。在2000年初的时候，在中国的投资策略，就是要围绕着13亿人口消费的需求。这是最看得见，最看得清的方向。'
            },
            {
              id: 3,
              text: '消费升级可能对于大众来讲它是一个永恒的主题。看中国的整个消费，从90年代中期开始到现在，已经算是第三次的消费升级了。'
            },
            {
              id: 4,
              text: 'NO.1'
            },
            {
              id: 5,
              text: '90年代中到2000年处的时候，那个时候的消费升级是大家有钱了，大家对买东西有选择，去选有品牌的，然后是可信赖的这些厂商生产的东西。中国在那个时期也诞生了一批快销品的品牌，比如说娃哈哈，还有蒙牛都是在那个时候诞生、成长起来的。那个时候中国开始喝瓶装水，开始喝早餐奶。相应的亚商投资了双汇、圣农，是规模化，有品牌的去生产猪肉和鸡肉等日常要消费的东西。'
            },
            {
              id: 6,
              text: 'NO.2'
            },
            {
              id: 7,
              text: '2000年前后是第二次的消费升级，那个时候对在哪里能买到想要的商品有了一些更多的需求。这就催生了一些连锁超市、便利店、包括电商也是在那个时候发展起来的。可以从更加方便的、更加有品牌可信赖的渠道去消费。在那个时候亚商投资了红旗连锁、东方时尚驾校、北京丽家宝贝等。我们定位在消费领域中更专业性，更专注于服务的公司。'
            },
            {
              id: 8,
              text: 'NO.3'
            },
            {
              id: 9,
              text: '现在讲最新的一次消费与升级，我们更看好年轻消费者对未来的消费需求。商品过度丰富，品牌过多的当下，需要一次消费升级，是想寻求一些更加个性化的，更加符合自己品位的，调性的新的东西，新的品牌，新的零售模式，或者一种更健康的产品和服务。这是我们看的消费升级。'
            },
            {
              id: 10,
              text: '亚商从前两年就开始投了一些类似于从网络品牌做起的企业，他们用户做大之后，意识到光从网上很难跟消费者建立一种更长期的认可和黏性，所以要从线上往线下走。亚商投了MISS CANDY，一开始在天猫店做得非常不错，16年开始已经布了线下，现在已经开了10多个线下店，真正形成了线上和线下的良性互动。这是除此之外，我们还投了亚缇克兰、音米眼镜、就医160、布拉旅行等针对年轻消费者喜好的新的消费品牌。'
            },
            {
              id: 11,
              text: '亚商从前两年就开始投了一些类似于从网络品牌做起的企业，他们用户做大之后，意识到光从网上很难跟消费者建立一种更长期的认可和黏性，所以要从线上往线下走。亚商投了MISS CANDY，一开始在天猫店做得非常不错，16年开始已经布了线下，现在已经开了10多个线下店，真正形成了线上和线下的良性互动。这是除此之外，我们还投了亚缇克兰、音米眼镜、就医160、布拉旅行等针对年轻消费者喜好的新的消费品牌。'
            },
            {
              id: 12,
              text: '说到消费，核心两点非常重要：'
            },
            {
              id: 13,
              text: '一个就是产品，或者说是服务。因为消费者最终购买的无非是某一类产品，或者某一类服务。只不过可能是时代不一样了，这个产品或者是服务表现形式可能会变化，但是最终还是离不开产品和服务本身，好的产品和好的服务总会占领消费者的心智。'
            },
            {
              id: 14,
              text: '第二个是体验。之前大家对体验不是那么强求，我只要买到好的东西就ok了。现在的消费者，特别是年轻一代的消费者，他对怎么买到产品和服务的过程也非常在乎。因为体验不好，可能不再购买。新零售，共享，包括一些金融服务，这些是来增强或者是提高消费者得到这个产品或者服务中间这个体验的过程：便利性、快速性，社交性。'
            },
            {
              id: 15,
              text: '新的消费升级，包括我们讲的新零售，只不过是把好的产品，好的服务，结合一些新的技术，新的手段，好的体验，交给消费者的手里。我认为将来可能不会有新零售的这个概念——所有的东西离不开产品和服务，和交易过程的体验。揉捏成一种综合的东西，打包去卖给消费者。这就是我理解的新消费，或者是暂存的新零售的概念。'
            },
            {
              id: 16,
              text: '最后用一句话总结：'
            },
            {
              id: 17,
              text: '站在创业的角度，消费者永远是王——只有理解你的消费者想要什么，你才能给他什么；而从投资的逻辑来讲，站在未来消费者的角度，去投能在未来给消费者带来满足和创造价值的东西。'
            }
          ]
        },
        {
          id: 1,
          imgUrl: news7cover,
          date: '2017年10月25日',
          tit: '亚商小文丨做股权投资必须具备的五种分裂型人格',
          time: '2017-10-25  亚商资本于伟霞、亚商ABC',
          summary: '',
          content: [
            {
              id: 0,
              pic: news7detail1
            },
            {
              id: 1,
              text: '股权投资被誉为金融界里“皇冠上的明珠”，传说中的投资人被描述成手握大把钞票的哆啦A梦，撒出去一叠，收回来十叠，各种火眼金睛、神通广大、能够给LP创造千百倍回报。'
            },
            {
              id: 2,
              text: ' 投资，如今成为年轻人争相涌入的行业。其实，如同任何行业一样，投资从业人员从入行到成长为一个成熟的投资人，要流过很多汗、趟过很多坑、打过很多怪，才能够逐步升级成长为一个合格的投资人。'
            },
            {
              id: 3,
              text: '除此之外，在这条铺满了鲜花和荆棘的路上，投资人还需要具备很多分裂的人格特质，才能在摸爬滚打中找得到前行的路。'
            },
            {
              id: 4,
              text: '经得起赞美，禁得住诋毁'
            },
            {
              id: 5,
              text: '这是范冰冰的名言，用来形容我们也非常合适。股权投资的成功比例，如果以上市退出而言，行业的平均水平是十之二三，如果以投到十倍以上回报的项目而言，是十之一二，如果就投到百倍乃至更高的独角兽明星项目而言，只能用“凤毛麟角”来形容了。虽然打开财经新闻，到处是投到各类独角兽的鸡血故事，但是你如果仔细统计一下，股权投资在中国三十年左右的时间，这类项目一共不会超过100个，这些被反复讲述和不断神话的故事里面的英雄人物，也必然伴随着数量更多的失败案例，因此，作为投资人，投资成功带来的赞美与失败带来的诋毁是相伴而生的。我经常说，在金钱面前，最能够考验人性的光辉，也最能够照见人性的阴暗，最有经验的舵手有时候也难免阴沟里面翻船，吃瓜群众会在你成功的时候欢呼，也会在你失败的时候毫不犹豫地吐上唾沫，而我们，必须永远站在那里，经得起赞美，禁得住诋毁。在成功时冷静、在失败时稳定。'
            },
            {
              id: 6,
              text: '既博学多才，又深度专注'
            },
            {
              id: 7,
              text: '股权投资是个非常长线的工作，从投入到退出，一般需要三到五年的时间，因此，我们投资的项目，在当前飞速变化的中国经济状况下，都要经历过至少一个经济周期，我们判断项目的时候必须要关注到未来几年的经济走势。作为投资人，要关注宏观经济的数据，关注PPI\CPI，关注经济政策和货币政策，关注政治态势和汇率变化。'
            },
            {
              id: 8,
              text: '人民币贬值了与你有关，因为有些投资项目的进口原材料的成本升高了；人民币升值了也与你有关，因为投资的项目外贸出口可能要受影响；美国大选了与你有关，因为美国的贸易战一旦开打，我们所投的对美出口项目会变化；伊朗局势危急也与你有关，因为投资的项目在当地刚拿了1亿美金的订单……很多朋友说，你们投资人真是博学多才，什么都懂，那实在是没办法啊，打开新闻看看，什么事都会在自己投资的项目里过一遍……这还只是一个方面，投项目，除了看懂行业，还要深度调研企业，更重要的是要看创始人的能力。看人从来都是一个非常高深的行业，我有一个做投资的朋友曾经很无奈的说，我觉得看人太难了，（是啊，看人准的都去算命了……）'
            },
            {
              id: 9,
              text: '因此投资人学习易经八卦、琢磨摸骨算命也不算是特别冷僻的爱好。有一个做早期的朋友开玩笑说，他投的天使项目，二轮融资的时候都要打一卦，如果算出来命里无大财他们就不跟投了，呵呵，打卦师傅才是投决会的核心成员啊……多么痛的领悟！'
            },
            {
              id: 10,
              text: '当然，这一切都是周边技能，一个优秀投资人最核心的能力就是判断力，一个行业的方向和走势如何？这个行业里这么多的项目，哪些是有核心竞争力能够跑出来的，上下游的状况对行业的影响是什么？要做出相对正确的判断，必须对将要投资的领域有深度而专注的研究，跟踪最新的技术变迁和行业趋势，弄懂里面的商业逻辑，搞清楚竞争态势和竞争态势的变迁，一个对行业没有深度研判的投资人，投资基本上是碰运气了。而判断力却不是看两个报告或者跟专家吃几次饭就能具备的，深度专注的行业跟踪和研究是必需的。'
            },
            {
              id: 11,
              text: '懂得高富帅、理解穷屌丝'
            },
            {
              id: 12,
              text: '股权基金管理有募投管退四个环节，每个环节接触的群体都有差异。'
            },
            {
              id: 13,
              text: '募资环节接触的大部分是大的金融机构和成熟企业的企业家，他们除工作外的爱好和交流经常是打打高尔夫、喝喝茶、品品红酒，因此，你总大概也要能下场挥两杆，说得出Petrus，latour，Mouton等名酒。而投资项目接触的多数还是处于创业或者成长阶段的企业，PE还好， VC的主要投资对象是初创企业，大部分都还是屌丝，创业不易，边吃路边摊边讨论商业模式，一样要激情四射火花四溅。有一个创业项目，为了节约成本，夏天40度没钱买空调，我们去尽调时，就在他们40度的热气腾腾的办公室里热情洋溢、汗流浃背地讨论了一下午他们的服务流程。'
            },
            {
              id: 14,
              text: '当然，这样的穿越和转换做多了，我们会越来越明白，人生的智慧和价值与你喝什么酒、开什么车并不一定相关，企业家是这个世界上最有创造力、最坚韧和最有责任心的群体，我们尊重一切努力实现自身价值和创造社会价值的企业家，不会因为你喜欢喝Latour或者青岛啤酒就对你有偏见。'
            },
            {
              id: 15,
              text: '在这样一个因为新技术带来巨大变迁的时代，没什么人能安心且安全地呆在原地，我们的目标就是在这样的动态图景中，找到那些看得见向上路径的人，并与他们成为伙伴。'
            },
            {
              id: 16,
              text: '自我坚持与自我否定'
            },
            {
              id: 17,
              text: '投资价值的实现就是你投资的企业接受了你的投资后变得更好，变好越多、价值越大。行业里的说法就是，投资投的是“未来”，而“未来”的主要的特点是“不确定性”，已经确定的叫做过去。因此，这个对未来的判断需要我们做各种假设，然后抽丝剥茧地进行分析推演，计算各种结果实现的概率以及过程中所要承担的风险，因此，有时候不同的人对同一个项目会得出严重不同的结论，往往，好的投资项目不一定能获得大多数人的认可。我们行业里有个说法“回报好的项目往往投资决策的时候分歧很大”，比如，如今互联网的两大巨头、两个小马哥，当初在很多机构的投决会里被否决过。因此，要成为一个有眼光的投资人，不能人云亦云，如果认为自己获得了正确结论，要坚持自我判断，并将这一判断明确地传达给投决会，有勇气在巨大的不确定性中坚持自我。'
            },
            {
              id: 18,
              text: '但是，市场上的小马哥毕竟是凤毛麟角，大多数时候，我们看了100个项目，才能够找到为数不多的几个可以投资的对象，因此，我们经常处在“假设—验证—否定”的循环中，我们要不断寻找自己逻辑的错误和漏洞，左右互博，不断自我否定而不能试图自圆其说，有多大的勇气坚持自我，你就必须有多大的勇气否定自我。在自我思辨的道路上痛苦地前行。'
            },
            {
              id: 19,
              text: '雌雄同体'
            },
            {
              id: 20,
              text: '投资是一个不分性别的行业，你必须有女性的细腻和敏感，同时也有男性的冷静和果敢；判断项目除了全方位的专业知识，还需要非常全面的现场调研和感知，我们曾经去看过一个项目，项目方在带我们看生产线现场的时候有些遮掩，这点细微的表情让我们起了疑心，虽然报表很好看，但是后来深入了解发现，他们在生产流程的一个环节上有些问题，导致成本比较高，于是果断放弃。'
            },
            {
              id: 21,
              text: '这个世界上没有完美的项目，项目的判断需要综合评估，需要抓取关键点，因此，项目要做成，需要非常决断，不能有因为个别不重要的细节而犹豫不决的女性化心里，项目投资和基金管理的工作都有着非常强的目标性和目标感，做了这个工作，你就是雌雄同体。作为一名女性从业者，经常被人打趣，说你们行业很多美女，我经常非常明确地告诉他们：错！我们这个行业的女性比例是比较低的，这个工作你必须经得起出差颠簸，扛得住高强度调研，能说能写，能思能记，哪里都睡得着，什么都吃得下。有公主病的女性莫入！哈哈！女性比例是不会高的，部分坚持下来的基本都是女汉子。'
            },
            {
              id: 22,
              text: '做投资就如同谈了一场全心投入、势均力敌又十分漫长的恋爱，十分欢愉又十分痛苦，前一秒种感觉自己已完全被掏空，后一秒钟又满血复活重新投入，在分裂中砥砺前行。'
            },
            {
              id: 23,
              text: '做投资就如同跑马拉松，目标是长且远的，也不是所有人都能够到达终点，过程中会不断觉得自己已经到极限，然后又不断地重新启动，很少人会觉得过程很轻松，可是爱上跑步的人下次还是会继续报名，爱的就是那个不断挑战和自虐的过程。'
            },
            {
              id: 24,
              text: '但是，如此地锤炼过后，一旦你能够驾轻就熟地运用这些“分裂型”人格，再加上一点狗屎运，你就很可能成为一个优秀的投资人。如果你天生自带这些“分裂型”人格，那么，欢迎你加入！并祝愿你在分裂的路上越走越远！'
            },
            {
              id: 25,
              text: '（本文由融资中国首发，原创作者为亚商资本合伙人于伟霞女士）'
            }
          ]
        },
        {
          id: 0,
          imgUrl: news8cover,
          date: '2017年',
          tit: '深圳亚商创新基金正式成立',
          time: '2017  亚商ABC',
          summary: '',
          content: [
            {
              id: 0,
              text: '在这里，想和大家聊一聊亚商的新动向。'
            },
            {
              id: 1,
              text: '从2016年年中开始筹备，历时一年，深圳亚商创新基金已经正式成立啦！！！亚商总部坐标于上海，驻扎北京深圳。作为投资界老兵，一直以来以稳健又不失创新的投资风格迈步前进。'
            },
            {
              id: 2,
              text: '此次，亚商与深圳中小微企业基金深度合作，成立10亿规模的深圳亚商创新投资中心。LP的持续看好和认可，是对我们莫大的激励和肯定。感谢各位投资人对我们一直以来的信任和支持。'
            },
            {
              id: 3,
              text: '深圳亚商创新基金将会继续秉承亚商的投资风格和节奏，理智与血性并存，发掘更多优秀潜力企业，为投资人带来可观的回报。'
            }
          ]
        }
      ]
    }
  },
  created () {
    window.scroll(0, 700)
  },
  mounted () {
    this.$nextTick(function () {
      // document.documentElement.scrollTop = 0;
      window.addEventListener('scroll', this.onScroll);
      // console.log(this.$route.params.renderContent);
      // this.$parent.$data.renderContent= this.$route.params.renderContent;
    })
  },
  methods: {
    onScroll () {
      let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrolled > 600) {
        $('.header').addClass('active');
      } else {
        $('.header').removeClass('active');
      }
    },
    showDetail: function (index) {
      this.showPopIndex = index;
      this.showMask = true;
      $('body').css('overflow', 'hidden');
    },
    closePop: function () {
      this.showMask = false;
      this.showPopIndex = -1;
      $('body').css('overflow', 'auto');
    },
    turnPagePrev(index){
      if (index > 0) {
        index--;
        this.showPopIndex = index;
        document.getElementById('pop').scrollTop = 0;
      }
    },
    turnPageNext(index){
      const len = this.newsList.length;
      if (index < len - 1) {
        index++;
        this.showPopIndex = index;
        document.getElementById('pop').scrollTop = 0;
      }
    }
  }
}
</script>

<style scoped>
.header{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 1250px;
  height: 100px;
  background: rgba(255, 255, 255, 0.2);
  -moz-background: rgba(255, 255, 255, 0.2);
  padding: 20px 200px;
  box-sizing: border-box;
  transition: all 0.8s;
  -moz-transition: all 0.8s;
  z-index: 9;
}
.header.active{
  background: #333367;
}
.header ul{
  display: table;
  table-layout: fixed;
  width: 70%;
  padding-left: 6%;
  box-sizing: border-box;
}
.header li{
  display: table-cell;
  width: 16.6%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 18px;
}
.header li a{
    color: #fff;
    font-size: 18px;
}
.header span{
  display: inline-block;
  color: #fff;
  border: 1px solid #fff;
  width: 34px;
  height: 34px;
  line-height: 34px;
  border-radius: 50%;
  text-align: center;
  margin-top: 12px;
  cursor: pointer;
}
.banner{
    min-width: 1200px;
}
.more{
    text-align: center;
    line-height: 50px;
    margin: 60px 0 40px 0;
    min-width: 1200px;
}
.more span{
    display: inline-block;
    vertical-align: middle;
}
.more .line{
    width: 160px;
    height: 4px;
    background: #c8001c;
}
.more .text{
    margin: 0 15px;
    font-size: 28px;
    color: #333366;
}
.news-content{
    width: 1200px;
    /*max-width: 1520px;*/
    margin: 0 auto;
}
.news-content .img{
    width: 100%;
    /*height: 370px;*/
    overflow: hidden;
}
.news-content .img img{
  width: 100%;
  height: 100%;
}
.news-content ul{
  width: 1192px;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}
.news-content ul li{
    /*float: left;*/
    cursor: pointer;
    position: relative;
    width: 384px;
    height: 296px;
    margin: 0 6.5px 42px 6.5px;
    -webkit-box-shadow: 0 0 16px 10px rgba(0, 0, 0, 0.03);
    box-shadow: 0 0 16px 10px rgba(0, 0, 0, 0.03);
    padding-bottom: 90px;
    overflow: hidden;
}
.news-content li:last-child{
    margin-right: 0;
}
.news-content ul .info{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #464775;
    height: 100px;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
    transition: all 0.6s;
    -moz-transition: all 0.6s;
    color: #fff;
}
.news-content .info span{
    display: block;
}
.news-content .info .date{
    font-size: 15px;
    margin: 14px 0;
}
.news-content .info .tit{
    font-size: 16px;
    line-height: 24px;
}
/* .news-left li:nth-child(2) .img,.news-center li:nth-child(1) .img,.news-right li:nth-child(3) .img{
    height: 562px;
} */

.mask{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
}
.mask .pop-box{
  width: 55%;
  height: 90%;
  min-width: 898px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.mask .pop{
  height: 100%;
  overflow-y: auto;
  padding: 90px 50px 40px 50px;
  box-sizing: border-box;
}
.mask .close{
  position: fixed;
  top: -20px;
  right: -20px;
  background: url('./icon-close1.png') no-repeat 0 0;
  background-size: 100%;
  width: 36px;
  height: 36px;
  cursor: pointer;
  z-index: 9;
}
.mask .close:hover{
  background: url('./icon-close2.png') no-repeat 0 0;
  background-size: 100%;
  width: 36px;
  height: 36px;
}
.mask .pop .tit-box{
    width: 100%;
    padding: 30px 0 0 0;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    background: #ffffff;
}
.mask .pop .tit{
  font-size: 18px;
  font-weight: 600;
  text-indent: 0;
  margin-bottom: 15px;
}
.mask .pop p{
  padding: 0 50px;
}
.mask .pop p,.mask .pop .detail{

    font-size: 16px;
    text-align: justify;
    text-indent: 2em;
    line-height: 26px;
}
.mask .pop .detail{
    text-indent: 0;
}
.mask .pop .line{
    height: 2px;
    background: #bfbfbf;
}
.mask .pop .time{
    color: #333366;
    margin-bottom: 10px;
    text-indent: 0;
    padding: 0;
}
.mask .pop .summary{
  line-height: 32px;
  margin-bottom: 50px;
  text-indent: 0;
}
.mask .pop .hot{
    display: inline-block;
    /* width: 154px; */
    width: 16%;
    height: 90px;
    line-height: 90px;
    text-align: center;
    background: #e90111;
    color: #fff;
    font-size: 54px;
}
.mask .pop .sum{
    display: inline-block;
    /* margin-left: 176px; */
    width: 80%;
}
.mask .pop .detail-pic{
    overflow: hidden;
    text-indent: 0;
    padding-bottom: 10px;
    text-align: center;
}
.mask .pop .imgDetail{
    font-size: 16px;
    color: #666;
    text-align: center;
    line-height: 18px;
    margin-bottom: 25px;
}
.mask .pop .detail div{
    text-indent: 2em;
    margin-bottom: 10px;
}
.mask .pop img{
  max-width: 690px;
}
.mask .prev-btn, .mask .next-btn{
  position: absolute;
  top: 50%;
  display: inline-block;
  width: 36px;
  height: 36px;
  cursor: pointer;
}
.mask .prev-btn{
  left: -50px;
  background: url('./prev-btn.png') no-repeat 0 0;
  background-size: 100%;
}
.mask .next-btn{
  right: -50px;
  background: url('./next-btn.png') no-repeat 0 0;
  background-size: 100%;
}
.fade-enter-active,.fade-leave-active{
  transition: all 0.5s;
}
.fade-enter,.fade-leave-to{
  opacity: 0;
}
@media screen and (max-width: 1450px) {
  .news-content ul .info{
    padding: 0 10px 0 15px;
  }
  .news-content .info .date{
      margin-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newsMore/newsMore.vue